import HowToUseIcon from '../Icons/HowToUseIcon';
import CreateRumbleIcon from '../Icons/CreateRumbleIcon';
import SetupRumbleIcon from '../Icons/SetupRumbleIcon';
import clsx from 'clsx';
import LogOutIcon from '../Icons/LogOutIcon';
import { useMediaQuery } from 'react-responsive';
import { NavLink } from 'react-router-dom';
import ListIcon from '../Icons/ListIcon';

interface INavLink {
  variant: 'howToUse' | 'list' | 'create' | 'setup' | 'logOut';
  tag?: 'NavLink' | 'Button';
  label: string;
  disabled?: boolean;
  onClick?: any;
  className?: string;
  to?: string;
}
export default function CustomNavLink({
  variant,
  tag = 'Button',
  label,
  disabled,
  onClick,
  className,
  to = '',
}: INavLink) {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return tag === 'NavLink' ? (
    <NavLink
      className={clsx(
        'h-10 max-tablet:h-11 max-tablet:w-11 max-tablet:rounded-full max-tablet:justify-center flex gap-3 items-center rounded-6 tablet:px-4 transition duration-300',
        disabled
          ? 'opacity-50 cursor-context-menu pointer-events-none'
          : 'hover:bg-white/[0.08]',
        className
      )}
      to={to}
      replace
      onClick={onClick}
      activeClassName={'bg-white/[0.08]'}
    >
      {variant === 'howToUse' ? <HowToUseIcon /> : null}
      {variant === 'list' ? <ListIcon /> : null}
      {variant === 'create' ? <CreateRumbleIcon /> : null}
      {variant === 'setup' ? <SetupRumbleIcon /> : null}
      {variant === 'logOut' ? <LogOutIcon /> : null}
      {!isMobile && label}
    </NavLink>
  ) : (
    <button
      className={clsx(
        'h-10 max-tablet:h-11 max-tablet:w-11 max-tablet:rounded-full max-tablet:justify-center flex gap-3 items-center rounded-6 tablet:px-4 transition duration-300',
        disabled
          ? 'opacity-50 cursor-context-menu pointer-events-none'
          : 'hover:bg-white/[0.08]',
        className
      )}
      onClick={onClick}
    >
      {variant === 'howToUse' ? <HowToUseIcon /> : null}
      {variant === 'create' ? <CreateRumbleIcon /> : null}
      {variant === 'setup' ? <SetupRumbleIcon /> : null}
      {variant === 'logOut' ? <LogOutIcon /> : null}
      {!isMobile && label}
    </button>
  );
}
